import styled from 'styled-components';

const StyledChatGpt = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100%; /* Prevents the whole component from pushing out */
  overflow-x: hidden; /* Safety to prevent horizontal scroll */
  position: relative;
  overflow: visible !important;

  .a_closeGpt {
    position: absolute;
    top: 5px;
    right: 15px; /* Moved slightly more to the left from the edge */

    width: 32px !important;
    height: 32px !important;
    padding: 0 !important;

    display: flex !important;
    align-items: center;
    justify-content: center;

    background: transparent !important;
    border: none !important;
    color: #ffffff !important; /* Changed to pure white for better visibility */
    font-size: 30px;
    cursor: pointer;
    z-index: 1001;
    line-height: 1;

    /* Hide ONLY on Desktop */
    @media screen and (min-width: 991px) {
      display: none !important;
    }

    &:hover {
      color: #ef4444;
      transform: scale(1.2);
    }
  }

  .chat-content-container {
    padding-top: 35px;
    width: 100%;
    /* Responsive Logic */
    @media screen and (max-width: 767px) {
      width: 100% !important;
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
      width: 90% !important;
    }
  }
  .search-form {
    margin: 1em 0;
    font-size: 14px;
    .form-control {
      height: 32px;
      background: #65686e;
      color: #fff;
      opacity: 0.4;
      border: 0;

      &:focus {
        opacity: 1;
      }
    }
    .form-control::placeholder {
      color: #e9e9e9;
    }
  }

  .a_upgradeButton {
    height: 32px;
    width: 105px;
  }

  .a_regenerate {
    width: max-content;
    background: transparent;
    border: 1px solid #6f7077;
    margin: 10px auto;
  }

  .answer-section span {
    color: #6f7077;
    font-size: 16px;
    margin-right: 3px;
  }
  .botSubmit {
    background: transparent;
    border: none;
    margin-left: -35px;
  }

  .input-group-append {
    z-index: 10;
  }

  .answer-container {
    height: 100%;
    max-height: calc(100% - 170px);
    overflow-y: auto;
    margin-bottom: 20px;
  }
`;

export default StyledChatGpt;
